const MutationTypes = {
  SET_USER: 'SET_USER',
  SET_EMAIL: 'SET_EMAIL',
  SET_AUTHENTICATING: 'SET_AUTHENTICATING',
}

export default MutationTypes
